import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const UserInfo = ({ ...props }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.open}
      onClose={props.closeUserInfo}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        id="responsive-dialog-title"
        align="center"
        style={{ color: "#001753", marginBottom: "15px" }}
      >
        User Info
      </DialogTitle>
      <DialogContent>
        <Box
          component="form"
          sx={{ display: "flex", flexDirection: "column", padding: "10px" }}
          style={{ minWidth: "300px" }}
          autoComplete="off"
        >
          <div style={{ display: "flex", marginBottom: "5px" }}>
            <p style={{ marginRight: "15px" }}>
              <strong>Company:</strong>
            </p>
            <p>{props.userInfo.company ? props.userInfo.company : "N/A"}</p>
          </div>
          <div style={{ display: "flex", marginBottom: "5px" }}>
            <p style={{ marginRight: "15px" }}>
              <strong>Name:</strong>
            </p>
            <p>
              {props.userInfo.name ? props.userInfo.name : "N/A"}{" "}
              {props.userInfo.surname ? props.userInfo.surname : "N/A"}
            </p>
          </div>
          <div style={{ display: "flex", marginBottom: "5px" }}>
            <p style={{ marginRight: "15px" }}>
              <strong>Email:</strong>
            </p>
            <p>{props.userInfo.username ? props.userInfo.username : "N/A"}</p>
          </div>
          <div style={{ display: "flex", marginBottom: "5px" }}>
            <p style={{ marginRight: "15px" }}>
              <strong>Address:</strong>
            </p>
            <p>
              {props.userInfo.postCode ? props.userInfo.postCode : "N/A"}{" "}
              {props.userInfo.place ? props.userInfo.place : "N/A"},{" "}
              {props.userInfo.address ? props.userInfo.address : "N/A"}
            </p>
          </div>
          <div style={{ display: "flex", marginBottom: "5px" }}>
            <p style={{ marginRight: "15px" }}>
              <strong>Phone:</strong>
            </p>
            <p>{props.userInfo.phone ? props.userInfo.phone : "N/A"}</p>
          </div>
          <div style={{ display: "flex", marginBottom: "5px" }}>
            <p style={{ marginRight: "15px" }}>
              <strong>Using language:</strong>
            </p>
            <p>{props.userInfo.language ? props.userInfo.language : "N/A"}</p>
          </div>
          <div style={{ display: "flex", marginBottom: "5px" }}>
            <p style={{ marginRight: "15px" }}>
              <strong>Payment with:</strong>
            </p>
            <p>{props.orderInfo?.paymentMethod ? props.orderInfo?.paymentMethod : "N/A"}</p>
          </div>
          <div style={{ display: "flex", marginBottom: "5px" }}>
            <p style={{ marginRight: "15px" }}>
              <strong>Amount:</strong>
            </p>
            <p>{props.orderInfo?.orderPrice ? `${props.orderInfo?.orderPrice} CHF` : "N/A"}</p>
          </div>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.closeUserInfo}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserInfo;
